"use strict";

exports.__esModule = true;
exports.AgendaFieldSet = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AgendaDevicesField = require("./AgendaDevicesField");
var _AgendaEventsField = require("./AgendaEventsField");
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ErrorContainer = _styledComponents["default"].div.withConfig({
  displayName: "AgendaFieldSet__ErrorContainer",
  componentId: "sc-19opos2-0"
})(["color:", ";"], (0, _Theme.val)("FormErrorColor"));
var AgendaFieldSet = exports.AgendaFieldSet = /*#__PURE__*/function (_Component) {
  function AgendaFieldSet() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(AgendaFieldSet, _Component);
  var _proto = AgendaFieldSet.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      isPlantAgenda = _this$props.isPlantAgenda,
      prefix = _this$props.prefix,
      form = _this$props.form,
      calendarConfig = _this$props.calendarConfig,
      onCreateEventConfig = _this$props.onCreateEventConfig,
      agenda = _this$props.agenda,
      onSelectEventConfig = _this$props.onSelectEventConfig,
      selectedEventConfigID = _this$props.selectedEventConfigID,
      error = _this$props.error;
    return /*#__PURE__*/_react["default"].createElement("div", null, !isPlantAgenda && /*#__PURE__*/_react["default"].createElement(_AgendaDevicesField.AgendaDevicesField, {
      prefix: prefix,
      form: form
    }), error ? /*#__PURE__*/_react["default"].createElement(ErrorContainer, null, error) : null, /*#__PURE__*/_react["default"].createElement(_AgendaEventsField.AgendaEventsField, {
      prefix: prefix,
      form: form,
      agenda: agenda,
      calendarConfig: calendarConfig,
      onCreateEventConfig: onCreateEventConfig,
      onSelectEventConfig: onSelectEventConfig,
      selectedEventConfigID: selectedEventConfigID
    }));
  };
  return AgendaFieldSet;
}(_react.Component);